import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addDoc,
  collection,
  doc,
  orderBy,
  query,
  serverTimestamp,
  onSnapshot,
  updateDoc,
  where,
  setDoc,
  getDocs,
} from 'firebase/firestore'
import { showLoader } from 'src/utils/loader'
import { db } from 'src/firebase/config'
import moment from 'moment'
import { fulfilled } from 'src/features/status'
import { toast } from 'react-toastify'
import { membershipAction, selectMembership } from 'src/features/membershipSlice'

const useMembership = () => {
  const dispatch = useDispatch()
  const { allCoupons, redeems } = useSelector(selectMembership)
  const [currentMonth] = useState(moment().format('MM'))
  const [currentYear] = useState(moment().format('YYYY'))

  const syncTimeLine = (member, year) => {
    showLoader(true)
    console.log('year', year)
    const q = query(
      collection(db, 'timeline'),
      where('year', '==', year.toString()),
      where('memberId', '==', member?.id),
      orderBy('createdAt', 'desc'),
    )
    dispatch(membershipAction.loadingTimeline())
    const unSubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        showLoader(false)
        var items = []
        querySnapshot.forEach((doc) => {
          if (doc.exists()) {
            let code = doc.data().code.split('_')
            if (code.length > 3) {
              code.pop()
            }
            items.push({
              ...doc.data(),
              id: doc.id,
              code: code.slice(0, 2).join('_'),
              month: code.pop(),
            })
          }
        })
        dispatch(
          membershipAction.syncTimeline({
            items: items,
            status: fulfilled,
          }),
        )
        showLoader(false)
      },
      (error) => {
        console.log(error)
        showLoader(false)
      },
    )
    return unSubscribe
  }

  /**
   * Not used
   * @param {*} member
   * @param {*} year
   */
  const getTimeLine = (member, year) => {
    showLoader(true)
    console.log('getTimeLine', year)
    const tableRef = collection(db, 'timeline')
    const q = query(
      tableRef,
      where('year', '==', year.toString()),
      where('memberId', '==', member?.id),
      orderBy('createdAt', 'desc'),
    )
    dispatch(membershipAction.loadingTimeline())
    getDocs(q)
      .then((querySnapshot) => {
        // console.log(`logs('${currentYear}')`);
        var items = []
        querySnapshot.forEach((doc) => {
          let code = doc.data().code.split('_')
          if (code.length > 3) {
            code.pop()
          }
          items.push({
            ...doc.data(),
            id: doc.id,
            code: code.slice(0, 2).join('_'),
            month: code.pop(),
          })
        })
        dispatch(
          membershipAction.syncTimeline({
            items: items,
            status: fulfilled,
          }),
        )
      })
      .finally(() => {
        showLoader(false)
      })
  }

  const syncAllCoupons = () => {
    const couponsRef = collection(db, 'allCoupons')
    return onSnapshot(
      query(couponsRef, where('status', '==', 'Publish')),
      (querySnapshot) => {
        var items = []
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          items.push({
            id: doc.id,
            ...data,
            createdAt: data?.createdAt && moment(data?.createdAt?.toDate()).format(),
            updatedAt: data?.updatedAt && moment(data?.updatedAt?.toDate()).format(),
          })
        })
        dispatch(
          membershipAction.syncAllCoupons({
            items: items,
            status: fulfilled,
          }),
        )
      },
      (error) => {
        console.log(error)
      },
    )
  }

  const syncMemberCoupons = (member) => {
    const couponsRef = doc(db, 'membersCoupon', member.id)
    return onSnapshot(
      query(couponsRef),
      (docSnap) => {
        if (docSnap.exists()) {
          dispatch(membershipAction.syncMemberCoupons(docSnap.data()))
        } else {
          const payload = {
            membership: allCoupons.items.map((item) => {
              return {
                code: item.code,
                yearly: item.yearly,
                level: item.level,
                type: item.type,
                // onceInMonth: item.onceInMonth,
                redeemMonth: 0,
                yearlyUsed: 0,
                monthlyUsed: 0,
              }
            }),
            createdAt: serverTimestamp(),
            status: 'a',
          }
          const docRef = doc(db, 'membersCoupon', member.id)
          toast.info('Generating coupons')
          setDoc(docRef, payload).then((docSnap) => {
            dispatch(membershipAction.syncMemberCoupons(docSnap.data()))
          })
        }
      },
      (error) => {
        console.log(error)
      },
    )
  }

  /**
   *
   * @param {*} payload
   * @param {*} memberId
   * @param {*} message
   */
  const assignCoupons = (payload, memberId, message) => {
    showLoader(true)
    payload.createdAt = serverTimestamp()
    const docRef = doc(db, 'membersCoupon', memberId)
    toast.info('Generating coupons')
    setDoc(docRef, payload)
      .then((docSnap) => {
        message && toast.success(message)
      })
      .catch((error) => {
        var errorMessage = error.message
        console.log('error', error)
        toast.error(errorMessage)
      })
      .finally(() => {
        showLoader(false)
      })
    // dispatch(membershipAction.unsetMember())
  }

  /**
   *
   * @param {*} payload
   * @param {*} memberId
   * @param {*} message
   */
  const updateCoupons = async (payload, memberId, message) => {
    showLoader(true)
    const docRef = doc(db, 'membersCoupon', memberId)
    payload.updatedAt = serverTimestamp()
    // toast.success('Updating coupons')
    return await updateDoc(docRef, payload)
      .then((docSnap) => {
        message && toast.success(message)
      })
      .catch((error) => {
        var errorMessage = error.message
        console.log('error', error)
        toast.error(errorMessage)
      })
      .finally(() => {
        showLoader(false)
      })
  }

  /**
   *
   * @param {*} memberId
   */
  const resetCoupons = async (memberId) => {
    showLoader(true)
    const payload = {
      membership: allCoupons.items.map((item) => {
        return {
          code: item.code,
          yearly: item.yearly,
          level: item.level,
          type: item.type,
          monthly: Math.ceil(item.yearly / 12),
          yearlyUsed: 0,
          monthlyUsed: 0,
        }
      }),
      updatedAt: serverTimestamp(),
    }
    const docRef = doc(db, 'membersCoupon', memberId)
    return await updateDoc(docRef, payload)
      .then((docSnap) => {
        toast.success('Members coupons rested')
      })
      .catch((error) => {
        var errorMessage = error.message
        console.log('error', error)
        toast.error(errorMessage)
      })
      .finally(() => {
        showLoader(false)
      })
  }

  /**
   * @param {*} payload
   * @param {string} currentYear
   * @param {string} memberId
   */
  const redeemCoupon = async (payload, memberCouponsUpdated, memberId) => {
    if (!memberId) {
      toast.error('id is required')
      return
    }
    if (!payload) {
      toast.error('payload is required')
      return
    }
    showLoader(true)
    await updateDoc(doc(db, 'membersCoupon', memberId), {
      membership: memberCouponsUpdated,
      updatedAt: serverTimestamp(),
    })
    payload.createdAt = serverTimestamp()
    await addDoc(collection(db, 'timeline'), payload)
    await updateDoc(doc(db, 'members', memberId), {
      lastRedemption: serverTimestamp(),
      updatedAt: serverTimestamp(),
    })
      .then((docSnap) => {
        if (payload.type === 'Coupon') {
          toast.success('Coupon Redeemed Successfully.')
        } else {
          toast.success('Benefit Applied Successfully.')
        }
      })
      .catch((error) => {
        var errorMessage = error.message
        console.log('error', error)
        toast.error(errorMessage)
      })
      .finally(() => {
        showLoader(false)
      })
  }

  // const syncRedeemDetails = (member) => {
  //   // console.log(member?.finish?.toDate())
  //   const endingYear = member?.finish
  //     ? moment(member?.finish?.toDate()).format('YYYY')
  //     : currentYear
  //   const calculatedYear = parseInt(endingYear) > parseInt(currentYear) ? endingYear : currentYear
  //   // const endingYear = currentYear
  //   console.log('calculatedYear', calculatedYear)
  //   setCurrentYear(calculatedYear)
  //   const membershipRef = collectionGroup(db, calculatedYear)
  //   const q = query(
  //     membershipRef,
  //     where('memberId', '==', member?.id),
  //     orderBy('createdAt', 'desc'),
  //   )
  //   const unSubscribe = onSnapshot(q, (querySnapshot) => {
  //     var redeemList = []
  //     querySnapshot.forEach((doc) => {
  //       if (doc.exists) {
  //         let code = doc.data().code.split('_')
  //         if (code.length > 3) {
  //           code.pop()
  //         }
  //         let redeemData = doc.data()
  //         redeemList.push({
  //           ...redeemData,
  //           // property: getProperty(redeemData.propertyId),
  //           code: code.slice(0, 2).join('_'),
  //           month: code.pop(),
  //         })
  //       }
  //     })
  //     var redeemCounts = allCoupons.items.map((list) => {
  //       return {
  //         code: list.code,
  //         yearly: list.yearly,
  //         onceInMonth: list.onceInMonth || false,
  //         level: list.level,
  //         type: list.type,
  //         monthly: Math.ceil(list.yearly / 12),
  //         yearlyUsed: redeemList.filter((v) => v.code === list.code).length || 0,
  //         monthlyUsed:
  //           redeemList.filter((v) => v.code === list.code && v.month === currentMonth).length || 0,
  //       }
  //     })
  //     dispatch(
  //       membershipAction.syncRedeems({
  //         items: redeemList,
  //         counts: redeemCounts,
  //       }),
  //     )
  //   })
  //   return unSubscribe
  // }

  // const redeemCounterDetails = () => {
  //   if (membership?.length > 0) {
  //     const redeemCounts = membership.map((list) => {
  //       return {
  //         code: list.code,
  //         yearly: list.yearly,
  //         monthly: Math.ceil(list.yearly / 12),
  //         yearlyUsed: redeemList.filter((v) => v.code === list.code).length || 0,
  //         monthlyUsed:
  //           redeemList.filter((v) => v.code === list.code && v.month === moment().format('MM'))
  //             .length || 0,
  //       }
  //     })
  //     const specialRedeemCounts = specialCoupons.map((list) => {
  //       return {
  //         code: list.code,
  //         yearly: list.yearly,
  //         monthly: Math.ceil(list.yearly / 12),
  //         yearlyUsed: redeemList.filter((v) => v.code === list.code).length || 0,
  //         monthlyUsed:
  //           redeemList.filter((v) => v.code === list.code && v.month === moment().format('MM'))
  //             .length || 0,
  //       }
  //     })
  //     // redeemCounts.concat(specialRedeemCounts)
  //     console.log(code, redeemCounts)
  //     return redeemCounts.find((c) => c.code === code)
  //   }
  //   return []
  // }

  return {
    allCoupons,
    coupons: allCoupons.items.filter((m) => m.type === 'Coupon'),
    benefits: allCoupons.items.filter((m) => m.type === 'Benefit'),
    specialCoupons: allCoupons.items.filter((m) => m.level === 'SP'),
    currentMonth,
    currentYear,
    redeems,
    syncAllCoupons,
    syncMemberCoupons,
    syncTimeLine,
    getTimeLine,
    assignCoupons,
    updateCoupons,
    redeemCoupon,
    resetCoupons,
  }
}

export { useMembership }
